import { render, staticRenderFns } from "./ClientsProfile.vue?vue&type=template&id=703a9554&"
import script from "./ClientsProfile.vue?vue&type=script&lang=js&"
export * from "./ClientsProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports